var _excluded = ["children", "arrow", "flip", "WrapperComponent", "ArrowComponent", "width", "maxWidth", "minWidth"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.assign.js";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useRef } from "react";
import Tippy from "@tippyjs/react/headless";

/** Общий компонент для Popover и Tooltip, наружу не поставляется */
export var PopoverBase = function PopoverBase(_ref) {
  var _props$popperOptions;

  var children = _ref.children,
      _ref$arrow = _ref.arrow,
      arrow = _ref$arrow === void 0 ? true : _ref$arrow,
      _ref$flip = _ref.flip,
      flip = _ref$flip === void 0 ? true : _ref$flip,
      WrapperComponent = _ref.WrapperComponent,
      ArrowComponent = _ref.ArrowComponent,
      width = _ref.width,
      maxWidth = _ref.maxWidth,
      minWidth = _ref.minWidth,
      props = _objectWithoutProperties(_ref, _excluded);

  // Дефолтные пропсы
  var defaultTippyProps = useRef({
    appendTo: "parent",
    placement: "top"
  }).current; // Модификатор для включения/отключения автофлипа

  var flipDisableModifier = useRef({
    name: "flip",
    options: {
      flipVariations: false,
      fallbackPlacements: []
    }
  }).current; // Модификатор для стрелки, min отступ 7px от стрелки до края поповера (нужно для кейса, когда есть радиус)

  var arrowModifier = useRef({
    name: "arrow",
    options: {
      padding: 7 // https://popper.js.org/docs/v2/modifiers/arrow/#padding

    }
  }).current; // Собираем модификатор в кучу (api popper.js)

  var modifiers = [arrowModifier].concat(_toConsumableArray(!flip ? [flipDisableModifier] : []), _toConsumableArray(((_props$popperOptions = props.popperOptions) === null || _props$popperOptions === void 0 ? void 0 : _props$popperOptions.modifiers) || []));
  return /*#__PURE__*/React.createElement(Tippy, _extends({}, defaultTippyProps, props, {
    popperOptions: _objectSpread(_objectSpread({}, props.popperOptions), {}, {
      modifiers: modifiers
    }),
    render: function render(attrs) {
      return /*#__PURE__*/React.createElement(WrapperComponent, _extends({}, attrs, {
        width: width,
        minWidth: minWidth,
        maxWidth: maxWidth
      }), props.content, arrow && /*#__PURE__*/React.createElement(ArrowComponent, {
        "data-popper-arrow": true
      }));
    }
  }), children);
};